/* santosh js - 2026-08-12 14:55 — restored real KartmaxProductLinks helper (was accidentally pasted into customjs.js). */
(function (global) {
  function readProductField(product, keys) {
    if (!product || typeof product !== "object") {
      return "";
    }

    for (let index = 0; index < keys.length; index += 1) {
      const value = product[keys[index]];
      if (typeof value === "string" && value.trim()) {
        return value.trim();
      }
    }

    return "";
  }

  function readProductNumber(product, keys) {
    if (!product || typeof product !== "object") {
      return null;
    }

    for (let index = 0; index < keys.length; index += 1) {
      const value = product[keys[index]];
      const amount = Number(value);
      if (Number.isFinite(amount)) {
        return amount;
      }
    }

    return null;
  }

  function slugifyProductName(name) {
    if (!name || typeof name !== "string") {
      return "";
    }

    return name
      .trim()
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function getShopifyRoot() {
    const root =
      global.Shopify &&
      global.Shopify.routes &&
      typeof global.Shopify.routes.root === "string"
        ? global.Shopify.routes.root
        : "/";

    return root.endsWith("/") ? root : root + "/";
  }

  function normalizeImageUrl(value) {
    if (!value || typeof value !== "string") {
      return "";
    }

    const trimmed = value.trim();
    if (!trimmed) {
      return "";
    }

    if (
      trimmed.indexOf("http://") === 0 ||
      trimmed.indexOf("https://") === 0 ||
      trimmed.indexOf("//") === 0
    ) {
      return trimmed;
    }

    return trimmed;
  }

  function extractHandleFromLegacyUrl(url) {
    if (!url || typeof url !== "string") {
      return "";
    }

    const trimmed = url.trim();
    const withoutQuery = trimmed.split(/[?#]/)[0];
    const fileName = withoutQuery.split("/").pop() || "";
    const htmlMatch = fileName.match(/^(.+)\.html$/i);

    if (htmlMatch && htmlMatch[1]) {
      return decodeURIComponent(htmlMatch[1]);
    }

    return "";
  }

  function extractProductHandleFromUrl(url) {
    if (!url || typeof url !== "string") {
      return "";
    }

    const trimmed = url.trim();
    const relativeMatch = trimmed.match(/\/products\/([^/?#]+)/i);
    if (relativeMatch) {
      return decodeURIComponent(relativeMatch[1]);
    }

    try {
      const parsed = new URL(trimmed, global.location.origin);
      const pathMatch = parsed.pathname.match(/\/products\/([^/?#]+)/i);
      if (pathMatch) {
        return decodeURIComponent(pathMatch[1]);
      }
    } catch (error) {
      return "";
    }

    return "";
  }

  // santosh js - 2026-08-13 17:40 — Kartmax url_key often 404s on Shopify; prefer /products/ handle.
  function collectProductHandleCandidates(product) {
    const candidates = [];

    function push(value) {
      if (typeof value !== "string") {
        return;
      }
      const handle = value.trim();
      if (!handle || candidates.indexOf(handle) !== -1) {
        return;
      }
      candidates.push(handle);
    }

    const productUrl = readProductField(product, [
      "url",
      "link",
      "product_url",
      "productUrl",
      "uri",
    ]);
    // Shopify-style URL first (valid for product.js / wishlist).
    push(extractProductHandleFromUrl(productUrl));

    push(
      readProductField(product, [
        "handle",
        "product_handle",
        "productHandle",
        "slug",
        "url_key",
        "urlKey",
      ]),
    );

    const colorOption =
      Array.isArray(product.color_options) && product.color_options.length
        ? product.color_options[0]
        : null;
    if (colorOption) {
      push(typeof colorOption.handle === "string" ? colorOption.handle : "");
      push(typeof colorOption.url_key === "string" ? colorOption.url_key : "");
      push(extractProductHandleFromUrl(colorOption.url || ""));
    }

    push(extractHandleFromLegacyUrl(productUrl));
    push(
      slugifyProductName(
        readProductField(product, ["name", "title", "product_name", "productName"]),
      ),
    );

    return candidates;
  }

  function resolveProductHandle(product) {
    const candidates = collectProductHandleCandidates(product);
    return candidates.length ? candidates[0] : "";
  }

  function resolveProductImage(product) {
    const directImage = normalizeImageUrl(
      readProductField(product, ["image", "featured_image", "featuredImage"]),
    );
    if (directImage) {
      return directImage;
    }

    const colorOption =
      Array.isArray(product.color_options) && product.color_options.length
        ? product.color_options[0]
        : null;
    if (colorOption && colorOption.image) {
      const colorImage = normalizeImageUrl(colorOption.image);
      if (colorImage) {
        return colorImage;
      }
    }

    if (Array.isArray(product.gallery) && product.gallery.length) {
      const galleryImage = normalizeImageUrl(product.gallery[0].image);
      if (galleryImage) {
        return galleryImage;
      }
    }

    return "";
  }

  function resolveProductPrice(product) {
    const discountedPrice = readProductNumber(product, [
      "discounted_price",
      "discountedPrice",
    ]);
    if (discountedPrice != null) {
      return discountedPrice;
    }

    return readProductNumber(product, ["price", "price_min", "priceMin"]);
  }

  function buildProductPagePath(product) {
    const handle = resolveProductHandle(product);
    if (handle) {
      return "/products/" + encodeURIComponent(handle);
    }

    const productUrl = readProductField(product, [
      "url",
      "link",
      "product_url",
      "productUrl",
      "uri",
    ]);
    if (productUrl) {
      try {
        const parsed = new URL(productUrl, global.location.origin);
        if (parsed.origin === global.location.origin) {
          return parsed.pathname + parsed.search + parsed.hash;
        }
        const externalHandle = extractProductHandleFromUrl(productUrl);
        if (externalHandle) {
          return "/products/" + encodeURIComponent(externalHandle);
        }
        return productUrl;
      } catch (error) {
        return productUrl;
      }
    }

    return "";
  }

  function buildProductPageUrl(product) {
    const path = buildProductPagePath(product);
    if (!path) {
      return "";
    }

    if (path.charAt(0) !== "/") {
      return path;
    }

    const root = getShopifyRoot();
    if (root === "/") {
      return path;
    }

    return root.replace(/\/$/, "") + path;
  }

  global.KartmaxProductLinks = {
    buildProductPagePath,
    buildProductPageUrl,
    collectProductHandleCandidates,
    resolveProductHandle,
    resolveProductImage,
    resolveProductPrice,
  };
})(typeof window !== "undefined" ? window : globalThis);
